export enum EMetaType {
    LANDMARKS = 'landmarks',
    CITIES = 'cities',
    COUNTIES = 'counties',
    ZIP = 'zip',
}
